import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { neutralDark40, neutralLight40, toRgba } from "../../../constants/colors";
import { sizes } from "../../../constants/spacing";
import { getFocusRingStyles } from "../../../util/focusRing";
import { withFocusToggleClassName } from "../../../util/withFocusClassName";
var focusRing = getFocusRingStyles({
  colorOverride: "currentColor",
  offset: 2,
  radius: 6,
  theme: "light",
  includeFocusPseudoClass: true
});
var hoverAndFocusBackground = toRgba(neutralLight40, 0.2);
var pressedBackground = toRgba(neutralDark40, 0.12);
var maybeApplyFocusBackground = function maybeApplyFocusBackground(_ref) {
  var focusMode = _ref.focusMode;
  return focusMode === "keyboard" ? "background-color: ".concat(hoverAndFocusBackground, ";") : "";
};
export var ToastActionStyled = withFocusToggleClassName(styled("button")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: inline-flex;\n    align-items: center;\n    box-sizing: border-box;\n    height: 32px;\n    min-width: 32px;\n    padding: 7px ", "px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: 600;\n    color: currentColor;\n\n    display: inline-flex;\n    align-items: center;\n    justify-content: space-around;\n    white-space: nowrap;\n\n    ", "\n\n    background-color: transparent;\n\n    &:hover {\n        background-color: ", ";\n    }\n\n    &:active {\n        background-color: ", ";\n    }\n\n    &:focus {\n        ", "\n    }\n"])), sizes.xxSmall, focusRing, hoverAndFocusBackground, pressedBackground, maybeApplyFocusBackground));
ToastActionStyled.displayName = "ToastActionContainer";
//# sourceMappingURL=ToastActionStyled.js.map